/** The admin page's form state and its two edges (SA-1040 §4.5). Pure. */
import type { QuoteDocumentSettings, QuoteDocumentWrite } from '@/services/quoteDocument'

export interface Form {
  companyName: string
  addressLines: string   // one line per row
  contactLines: string
  legalLine: string
  logoMediaRef: string | null
  logoMimeType: string | null
  pageSize: 'A4' | 'Letter'
  terms: string
  emailSubject: string
  emailBody: string
}

export function toForm(read: QuoteDocumentSettings): Form {
  return {
    companyName: read.companyName, addressLines: read.addressLines.join('\n'), contactLines: read.contactLines.join('\n'),
    legalLine: read.legalLine, logoMediaRef: read.logoMediaRef, logoMimeType: read.logoMimeType, pageSize: read.pageSize,
    terms: read.terms, emailSubject: read.emailSubject, emailBody: read.emailBody,
  }
}

const lines = (text: string): string[] => text.split('\n').map((l) => l.trim()).filter(Boolean)

export function toWrite(form: Form): QuoteDocumentWrite {
  const hasLogo = !!form.logoMediaRef && !!form.logoMimeType
  return {
    company_name: form.companyName, address_lines: lines(form.addressLines), contact_lines: lines(form.contactLines),
    legal_line: form.legalLine, logo_media_ref: hasLogo ? form.logoMediaRef : null, logo_mime_type: hasLogo ? form.logoMimeType : null,
    page_size: form.pageSize, terms: form.terms, email_subject: form.emailSubject, email_body: form.emailBody,
  }
}
